import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useReaderStore = create(
  persist(
    (set, get) => ({
      progress: {},   // { chapterId: currentPageIndex }
      completed: {},  // { chapterId: true }

      setProgress: (chapterId, page) =>
        set({ progress: { ...get().progress, [chapterId]: page } }),

      getProgress: (chapterId) => get().progress[chapterId] || 0,

      markCompleted: (chapterId) =>
        set({ completed: { ...get().completed, [chapterId]: true } }),

      isCompleted: (chapterId) => !!get().completed[chapterId],

      clearMangaProgress: (chapterIds) => {
        const progress = { ...get().progress }
        const completed = { ...get().completed }
        chapterIds.forEach((id) => {
          delete progress[id]
          delete completed[id]
        })
        set({ progress, completed })
      },
    }),
    { name: 'reader' }
  )
)
